<div class="modal-header py-2 bg-dark text-light">
    <h4 class="modal-title">
        위험운전이력 상세
    </h4>
</div>

<div class="modal-body">
    <div class="h5 font-weight-normal mb-0">
        {{ruleConf?.dtgDriveRuleTypeNm}}
    </div>
    <div [ngSwitch]="ruleConf?.dtgDriveRuleType" class="mt-2">
        <div *ngSwitchCase="'1'">
            도로제한속도 <span class="text-info mx-2">{{ruleConf.dtgMaxSpeed}} km/h</span> 보다
            <span class="text-info mx-2">{{ruleConf.dtgCheckSpeed}} km/h</span> 초과 운행 한 경우
        </div>
        <div *ngSwitchCase="'2'">
            도로제한속도 <span class="text-info mx-2">{{ruleConf.dtgMaxSpeed}} km/h</span> 보다
            <span class="text-info mx-2">{{ruleConf.dtgCheckSpeed}} km/h</span> 초과해서
            <span class="text-info mx-2">{{ruleConf.dtgCheckSec / 60}}</span> 분 이상 운행 한 경우
        </div>
        <div *ngSwitchCase="'3'">
            <span class="text-info mx-2">{{ruleConf.dtgMaxSpeed}} km/h</span> 이상 속도에서
            초당 <span class="text-info mx-2">{{ruleConf.dtgCheckSpeed}} km/h</span> 이상 가속 운행하는 경우
        </div>
        <div *ngSwitchCase="'4'">
            <span class="text-info mx-2">{{ruleConf.dtgMaxSpeed}} km/h</span> 이하 속도에서 출발하여
            초당 <span class="text-info mx-2">{{ruleConf.dtgCheckSpeed}} km/h</span> 이상 가속 운행하는 경우
        </div>
        <div *ngSwitchCase="'5'">
            초당 <span class="text-info mx-2">{{ruleConf.dtgCheckSpeed}} km/h</span> 이상 감속 운행하고
            속도가 <span class="text-info mx-2">{{ruleConf.dtgMaxSpeed}} km/h</span> 이상인 경우
        </div>
        <div *ngSwitchCase="'6'">
            초당 <span class="text-info mx-2">{{ruleConf.dtgCheckSpeed}} km/h</span> 이상 감속하여
            속도가 <span class="text-info mx-2">{{ruleConf.dtgMaxSpeed}} km/h</span> 이하가 된 경우
        </div>
        <div *ngSwitchCase="'7'">
            속도가 <span class="text-info mx-2">{{ruleConf.dtgMaxSpeed}} km/h</span> 이상에서
            진행방향이 좌/우측 <span class="text-info mx-2">{{ruleConf.dtgCheckDir}}도/sec</span> 이상으로 차로 변경하고<br>
            <span class="text-info mx-2">{{ruleConf.dtgCheckSec}}</span> 초 동안 누적각도가
            <span class="text-info mx-2">{{ruleConf.dtgCheckDir2}}도/sec</span> 이하,
            가감속이 초당 <span class="text-info mx-2">{{ruleConf.dtgCheckSpeed}} km/h</span> 이하인 경우
        </div>
        <div *ngSwitchCase="'8'">
            속도가 <span class="text-info mx-2">{{ruleConf.dtgMaxSpeed}} km/h</span> 이상에서
            진행방향이 좌/우측 <span class="text-info mx-2">{{ruleConf.dtgCheckDir}}도/sec</span> 이상으로 차로 변경하고<br>
            <span class="text-info mx-2">{{ruleConf.dtgCheckSec}}</span> 초 동안 누적각도가
            <span class="text-info mx-2">{{ruleConf.dtgCheckDir2}}도/sec</span> 이하,
            가속이 초당 <span class="text-info mx-2">{{ruleConf.dtgCheckSpeed}} km/h</span> 이상인 경우
        </div>
        <div *ngSwitchCase="'9'">
            속도가 <span class="text-info mx-2">{{ruleConf.dtgMaxSpeed}} km/h</span> 이상이고
            <span class="text-info mx-2">{{ruleConf.dtgCheckSec}}</span> 초 안에 좌/우측 누적 회전각이
            <span class="text-info mx-2">{{ruleConf.dtgCheckDir}} ~ {{ruleConf.dtgCheckDir2}}</span> 도 범위로 급회전하는 경우
        </div>
        <div *ngSwitchCase="'10'">
            속도가 <span class="text-info mx-2">{{ruleConf.dtgMaxSpeed}} km/h</span> 이상이고
            <span class="text-info mx-2">{{ruleConf.dtgCheckSec}}</span> 초 안에 좌/우측
            <span class="text-info mx-2">{{ruleConf.dtgCheckDir}} ~ {{ruleConf.dtgCheckDir2}}</span> 도 범위로 운행한 경우
        </div>
        <div *ngSwitchCase="'11'">
            운행시간이 <span class="text-info mx-2">{{ruleConf.dtgMaxSpeed}} 시간</span> 이상 운행
            <span class="text-info mx-2">{{ruleConf.dtgCheckSec}}</span> 분 이하 휴식일 경우
        </div>
        <div *ngSwitchCase="'101'">
            주행중 속도가 <span class="text-info mx-2">{{ruleConf.dtgMaxSpeed}} km/h</span> 인 경우
        </div>
        <div *ngSwitchCase="'102'">
            속도가 <span class="text-info mx-2">{{ruleConf.dtgMaxSpeed}} km/h</span> 이고
            RPM 이 <span class="text-info mx-2">{{ruleConf.dtgCheckRpm}}</span> 이상인 경우
        </div>
    </div>

    <div class="table-responsive overflow-auto mt-4">
        <table class="table table-sm table-hover align-items-center text-nowrap mb-0">
            <thead>
                <tr class="text-center">
                    <th>
                        운행일시
                    </th>
                    <th>
                        속도
                    </th>
                    <th>
                        방향
                    </th>
                    <th>
                        rpm
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of listItem;let idx = index;">
                    <td class="text-center">
                        {{item.dtgRegDt}}
                    </td>
                    <td class="text-right">
                        <span class="mx-1 text-muted" *ngIf="item.dtgSpeedDiff >= 0">
                            ( +{{item.dtgSpeedDiff | number:'0.0-1'}} )
                        </span>
                        <span class="mx-1 text-muted" *ngIf="item.dtgSpeedDiff < 0">
                            ( {{item.dtgSpeedDiff | number:'0.0-1'}} )
                        </span>
                        <span>
                            {{item.dtgSpeed | number:'0.0-1'}}
                        </span>
                    </td>
                    <td class="text-right">
                        <span class="mx-1 text-muted">
                            ( {{item.dtgGpsDirectionDiff}} )
                        </span>
                        <span>
                            {{item.dtgGpsDirection}}
                        </span>
                    </td>
                    <td class="text-right">
                        {{item.dtgRpm | number}}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="mt-3">
        <list-paging
            [inputPagingInfo]="pagingInfo"
            (callbackClickPageNumber)="callbackClickPageNumber($event)"
            (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-sm"
        (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        <span class="ml-1">
            닫기
        </span>
    </button>
</div>